import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';
import { SegmentedControl } from '@/components/molecules/SegmentedControl';

import { TIMELINE_ZOOMS, type TimelineZoom } from '../../helpers/timelineZoom';

import styles from './TimelineZoomBar.module.scss';

interface TimelineZoomBarProps {
    zoom: TimelineZoom;
    onZoomChange: (zoom: TimelineZoom) => void;
    /** Null when today is off the axis. */
    onToday: (() => void) | null;
}

/** A long cycle's zoom (Week, Month, Whole stocking) and the way back to today. */
export default function TimelineZoomBar(props: TimelineZoomBarProps) {
    const { zoom, onZoomChange, onToday } = props;
    const { t } = useTranslation('fishGroups');
    const options = TIMELINE_ZOOMS.map((value) => ({ value, label: t(`board.zoom.${value}`) }));

    return (
        <div className={styles.bar}>
            <SegmentedControl
                options={options}
                value={zoom}
                onChange={onZoomChange}
                size="small"
                aria-label={t('board.zoom.label')}
            />
            <Button
                variant="secondary"
                size="small"
                disabled={onToday === null}
                tooltip={t('board.zoom.todayTooltip')}
                onClick={onToday ?? undefined}>
                {t('board.zoom.today')}
            </Button>
        </div>
    );
}
